/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useContext, useEffect, useState, useMemo} from "react";
import {Alert, Spin, Tabs} from "antd";
import useRMateChart from "./useRMateChart";
import MapPropsContext from "../MapPropsContext";
import useDebounce from "../../../utils/hooks/useDebounce";
import {getApiHost} from "../../../utils";
import Axios from "axios";
import ChartPane from "./ChartPane";
import {
  layoutForPie3DChart, dataReturnByDataType, layoutForChart1
} from "./RMateChartSpecificShipUtils";


const RMateChartSpecificShip = ({disabled}) => {

  const {
    chartAjaxParams,
    widgetState,
  } = useContext(MapPropsContext);

  // display_code_stats => '01' : '톤수별', '02': '항해구역별', '03': '선종별'
  const {display_code_stats} = widgetState;

  const {
    sidoCode,
    searchYear,
    chkString01,
    chkString02,
    chkString03,
    prm_check, prm_check_label,
    prm_check2, prm_check2_label,
    prm_check3, prm_check3_label,
    cmb_gubun_chart,
  } = chartAjaxParams;

  const [isInit, setIsInit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [prevParams, setPrevParams] = useState();
  const [parsedObject, setParsedObject] = useState({});
  const [prevGubunParams, setPrevGubunParams] = useState({});
  const [onlyLayoutChange, setOnlyLayoutChange] = useState(false);

  useEffect(() => {
    const param = {
      cmb_gubun_chart
    };
    if (JSON.stringify(prevGubunParams) !== JSON.stringify(param)) {
      setPrevGubunParams(param);
      setOnlyLayoutChange(true);
    } else {
      setOnlyLayoutChange(false);
    }
  }, [chartAjaxParams]);

  useDebounce(() => {
      if (isInit) {
        const url = getApiHost() + '/rwdinfolabstats/getSpcifyRdwStats.json';

        const newParams = {
          sidoCode,
          searchYear,
          chkString01,
          chkString02,
          chkString03,
        };

        if (!disabled && (JSON.stringify(prevParams) !== JSON.stringify(newParams))) {
          setPrevParams(newParams);
          setIsLoading(true);
          setParsedObject({}); // 초기화

          Axios.get(url, {params: newParams})
            .then(({data}) => {
              const chart1List = data['itemArea'].sort(function(a, b) {
                return a.DATA_SUM_CNT - b.DATA_SUM_CNT;
              });
              const {chart2List, chart3List, chart4List} = dataReturnByDataType(data['item']);
              setParsedObject({
                chart1List, chart2List, chart3List, chart4List
              });

            })
            .catch(e => console.error(e))
            .finally(() => {
              setIsLoading(false);
            });
        }
      }
    },
    1000,
    [isInit, prevParams, chartAjaxParams, setIsLoading]);

  const {
    chart1List, chart2List, chart3List, chart4List
  } = parsedObject;

  const [activeTabInfo , setActiveTabInfo] = useState('chart1');
  const activeTabKey = useMemo(() => {
    return activeTabInfo;
  }, [activeTabInfo]);

  const onChangeTab = useCallback((keys) => {
    setActiveTabInfo(keys);
  }, []);

  useEffect(() => {
    setActiveTabInfo('chart1');
  }, [display_code_stats]);

  return useRMateChart({
    init: () => setIsInit(true),
    style: {minHeight: '540px'},
    disabled,
    children: (
      <div style={{position: 'relative', height: '100%', width: '100%'}}>
        {/*{isLoading && <Spin style={{position: 'absolute', left: '50%', top: '50%', zIndex: 1}} size={"large"}/>}*/}
        {isLoading &&
          <div style={{position: 'absolute', top: 55, zIndex: 1, height: '90%', width: '100%', backgroundColor: 'white'}}>
            <Spin size={"large"}>
              <Alert
                message="차트 로딩 중"
                description="선택한 무선국의 정보를 불러오는 중입니다.."
                type="info"
                showIcon
                style={{height: '470px'}}
              />
            </Spin>
          </div>
        }
        <Tabs type={"card"} activeKey={activeTabKey} onChange={onChangeTab}>
          <Tabs.TabPane key={"chart1"} tab={`지역별 선박국 무선국 수 - ${getLabelForYearMonth(searchYear)}`}>
            <ChartPane data={chart1List}
                       onlyLayoutChange={onlyLayoutChange}
                       layoutParam={cmb_gubun_chart}
                       processor={() => chart1List}
                       layoutProcessor={() => layoutForChart1(CHART1_LAYOUT_PROPS, {
                         cmb_gubun_chart, searchYear,
                         prm_check, prm_check_label, prm_check2, prm_check2_label, prm_check3, prm_check3_label
                       })}
                       style={
                         chart1List && chart1List.length > 16
                           ? {height: chart1List.length * 30}
                           : {height: 470}
                       }/>
          </Tabs.TabPane>
          <Tabs.TabPane key={"chart2"} tab={`항해구역별 현황 - ${getLabelForYearMonth(searchYear)}`}>
            <ChartPane data={chart2List}
                       processor={() => chart2List}
                       layoutProcessor={() => layoutForPie3DChart(CHART2_LAYOUT_PROPS, {
                         searchYear,
                         prm_check: prm_check,
                         prm_check_label: prm_check_label,
                       })}
                       style={{height: 470, width: '100%'}}/>
          </Tabs.TabPane>
          <Tabs.TabPane key={"chart3"} tab={`톤수별 현황 - ${getLabelForYearMonth(searchYear)}`}>
            <ChartPane data={chart3List}
                       processor={() => chart3List}
                       layoutProcessor={() => layoutForPie3DChart(CHART3_LAYOUT_PROPS, {
                         searchYear,
                         prm_check: prm_check2,
                         prm_check_label: prm_check2_label,
                       })}
                       style={{height: 470, width: '100%'}}/>
          </Tabs.TabPane>
          <Tabs.TabPane key={"chart4"} tab={`선종별 현황 - ${getLabelForYearMonth(searchYear)}`}>
            <ChartPane data={chart4List}
                       processor={() => chart4List}
                       layoutProcessor={() => layoutForPie3DChart(CHART4_LAYOUT_PROPS, {
                         searchYear,
                         prm_check: prm_check3,
                         prm_check_label: prm_check3_label,
                       })}
                       style={{height: 470, width: '100%'}}/>
          </Tabs.TabPane>
        </Tabs>
      </div>
    ),
  })
};

const getLabelForYearMonth = (yearMonth) => {
  if (yearMonth) {
    if (yearMonth.length === 4) {
      return `${yearMonth}년`;
    } else if (yearMonth.length === 6) {
      return `${parseInt(yearMonth.substr(0, 4))}년`;
    }
  }
  return yearMonth;
};

const CHART1_LAYOUT_PROPS = {
  title: "지역별 선박국 무선국 수",
  xtitle: "무선국 수",
  ytitle: "지역명",
  chartType: "Multi Series Stacked Bar",
  layOutStyle: "Detail",
  masterName: "무선국 수",
  valueFixed: 0,
};

const CHART2_LAYOUT_PROPS = {
  title: "항해구역별 현황",
  xtitle: "항해구역 명",
  ytitle: "무선국 수",
  chartType: "Pie3DChart",
  layOutStyle: "Master",
  masterName: "2",
  valueFixed: 0,
};

const CHART3_LAYOUT_PROPS = {
  title: "톤수별 현황",
  xtitle: "톤수 명",
  ytitle: "무선국 수",
  chartType: "Pie3DChart",
  layOutStyle: "Master",
  masterName: "",
  valueFixed: 5,
};

const CHART4_LAYOUT_PROPS = {
  title: "선종별 현황",
  xtitle: "선종",
  ytitle: "무선국 수",
  chartType: "Pie3DChart",
  layOutStyle: "Master",
  masterName: "3",
  valueFixed: 5,
};


export default RMateChartSpecificShip;
